import React from "react";
import { Link } from "react-router-dom";

// Sizes match the container of the logo (icon + wordmark).
// The pulse ring lives on the wrapper (::before). Use `animated` for hero-sized logos.
export default function Logo({ variant = "dark", size = "md", animated = false, framed = false, className = "" }) {
  const sizes = {
    sm: "h-9",
    md: "h-11",
    lg: "h-16",
    xl: "h-24",
    hero: "h-28 sm:h-36 lg:h-44",
  };
  const cls = sizes[size] || sizes.md;
  const lightWrap = variant === "light" ? "bg-white rounded-xl px-2 py-1.5" : "";
  const framedImageScale = framed && size === "hero" ? "scale-[1.28] sm:scale-[1.32]" : "";

  const image = (
    <img
      src="/logo-teamwork.png"
      alt="Team Work Africa"
      className={`${cls} w-auto block ${framedImageScale} ${animated ? "tw-logo-img" : ""}`}
      draggable={false}
    />
  );

  return (
    <Link to="/" aria-label="Team Work Africa" data-testid="site-logo" className={`inline-flex items-center ${className}`}>
      {framed ? (
        <span
          className={`${animated ? "tw-logo-wrap" : "inline-flex"} relative rounded-[28px] px-4 py-4 sm:px-5 sm:py-5
            bg-white/95 backdrop-blur
            ring-1 ring-brand-orange/20
            shadow-[0_28px_60px_-24px_rgba(14,37,58,0.28),0_0_0_1px_rgba(14,37,58,0.04)]
            before:absolute before:inset-0 before:rounded-[28px]
            before:bg-gradient-to-br before:from-brand-orange/8 before:via-transparent before:to-brand-navy/10
            before:pointer-events-none`}
          data-testid="hero-logo-frame"
        >
          {/* subtle corner accents */}
          <span aria-hidden className="pointer-events-none absolute -top-1.5 -left-1.5 h-4 w-4 border-t-2 border-l-2 border-brand-orange rounded-tl-lg" />
          <span aria-hidden className="pointer-events-none absolute -top-1.5 -right-1.5 h-4 w-4 border-t-2 border-r-2 border-brand-orange rounded-tr-lg" />
          <span aria-hidden className="pointer-events-none absolute -bottom-1.5 -left-1.5 h-4 w-4 border-b-2 border-l-2 border-brand-orange rounded-bl-lg" />
          <span aria-hidden className="pointer-events-none absolute -bottom-1.5 -right-1.5 h-4 w-4 border-b-2 border-r-2 border-brand-orange rounded-br-lg" />
          {image}
        </span>
      ) : (
        <span className={`${animated ? "tw-logo-wrap" : "inline-flex"} ${lightWrap}`}>{image}</span>
      )}
    </Link>
  );
}
